import { parseUrl } from 'query-string'

import { CLIENTSIDE_HOOK_DATA_ATTR } from 'views/assets/scripts/consts'
import { getIEVersion } from 'views/assets/scripts/browsers'

import {
  SLIDE_ANCHOR_SELECTED_CLASS,
  SLIDER_BASE_OPTIONS,
  FIXED_HEIGHT_CLASS,
  SLIDER_ITEM_SELECTOR
} from './consts'

/* eslint-disable-next-line  arrow-body-style */
export const buildScopedSliderSelector = scope => child => {
  return scope && child ? `[data-scope="${scope}"] ${child}` : null
}

/* eslint-disable-next-line  arrow-body-style */
export const buildScopedModalSelector = modalId => child => {
  return modalId && child ? `#${modalId} ${child}` : null
}

/**
 * Get distinct slides map
 *
 * @param {NodeList} slidesList
 * @returns {object<string, string>}
 */
export const getImageToSlideMap = slidesList => {
  const map = {}
  const indexRegEx = /\d+$/

  Array.prototype.forEach.call(slidesList, slide => {
    // Extract index from slide ID
    if (slide.id && indexRegEx.test(slide.id)) {
      const link = slide.querySelector('a')
      const itemIndex = slide.id.match(indexRegEx)[0]

      if (!link) {
        return
      }

      const href = link.getAttribute('href')
      const { url: imageFileName } = parseUrl(href.split('/').pop())

      map[imageFileName] = itemIndex
    }
  })

  return map
}

export const changeSelectedThumbnail = (navThumbsList, selectedLink) => {
  Array.prototype.forEach.call(navThumbsList, link =>
    link.classList.remove(SLIDE_ANCHOR_SELECTED_CLASS)
  )
  selectedLink.classList.add(SLIDE_ANCHOR_SELECTED_CLASS)
}

/**
 * Display correct major slide on nav thumb click
 *
 * @param {NodeList} navThumbsList
 * @param {tns} majorSlider
 * @param {object<string, string>} imageToSlideMap
 */
export const bindThumbsClick = ({
  navThumbsList,
  majorSlider,
  imageToSlideMap
}) => {
  Array.prototype.forEach.call(navThumbsList, link => {
    link.addEventListener('click', () => {
      const href = link.getAttribute('href')
      const { url: imageFileName } = parseUrl(href.split('/').pop())

      changeSelectedThumbnail(navThumbsList, link)

      if (imageToSlideMap[imageFileName]) {
        majorSlider.goTo(imageToSlideMap[imageFileName])
      }
    })
  })
}

/**
 * Remove all clientside hooks from NodeList
 */
export const removeClientsideHooks = nodelist => {
  ;[...nodelist].forEach(el => el.removeAttribute(CLIENTSIDE_HOOK_DATA_ATTR))
}

/**
 * Set first thumbnail as selected
 *
 * @param {NodeList} navThumbsList
 */
export const setSelectedFirstThumbnail = navThumbsList => {
  const firstThumbnail = navThumbsList[0]

  if (firstThumbnail) {
    firstThumbnail.classList.add(SLIDE_ANCHOR_SELECTED_CLASS)
  }
}

export const getSliderBaseOptions = () =>
  getIEVersion() === 11
    ? { ...SLIDER_BASE_OPTIONS, lazyload: false }
    : SLIDER_BASE_OPTIONS

export const getHighestItem = items => {
  let height = 0

  Array.prototype.forEach.call(items, item => {
    if (
      item.clientHeight > height &&
      !item.classList.contains(FIXED_HEIGHT_CLASS)
    ) {
      height = item.clientHeight
    }
  })

  return height
}

export const updateHeight = list => {
  const items = list.querySelectorAll('li')
  const maxHeight = getHighestItem(items)

  if (maxHeight > 0) {
    Array.prototype.forEach.call(items, item => {
      const currentHeight = item.clientHeight
      if (
        currentHeight < maxHeight ||
        item.classList.contains(FIXED_HEIGHT_CLASS)
      ) {
        /* eslint-disable-next-line no-param-reassign */
        item.querySelector(SLIDER_ITEM_SELECTOR).style.height = `${maxHeight}px`
        if (!item.classList.contains(FIXED_HEIGHT_CLASS)) {
          item.classList.add(FIXED_HEIGHT_CLASS)
        }
      }
    })
  }
}
